
import React, { useEffect, useState } from 'react';
import { Button, Image, Layout, message, Modal, Space, Table, Tabs } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { deleteFranchaise, deletePlan, getAllPlans } from '../../redux/actions/AllActions'
import { Content } from 'antd/es/layout/layout';
import Loading from '../../components/Loading/Loading';
import PlanDetails from '../../components/Deatails/PlanDetails/PlanDetails';
import Filter from '../../components/Filter/Filter';
import AddPlan from '../Add/AddPlan/AddPlan';
import EditPlan from '../Edit/EditPlan/EditPlan';


const { TabPane } = Tabs;
const Plan = () => {
    const [activeKey, setActiveKey] = useState("1");
    const handleChange = (key) => {
        setActiveKey(key);
    }
    const [addPlanModel, setAddPlanModel] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { data, loading } = useSelector((state) => state.data);
    const [filteredItems, setFilteredItems] = useState([]);
    const [isEditingModelVisible, setIsEditingModelVisible] = useState(false);
    const [isCreateModelVisible, setIsCreateModelVisible] = useState(false);
    const [handleDetailsVisible, setHandleDetailsVisible] = useState(false);
    const [editingRecord, setEditingRecord] = useState(null);
    const [admin, setAdmin] = useState("");

    useEffect(() => {
        const adminData = localStorage.getItem("admindata");
        try {
            const parsedData = JSON.parse(adminData);
            if (parsedData && typeof parsedData === "object") {
                setAdmin(parsedData);
            } else {
                console.error("Invalid admin data structure");
                localStorage.removeItem("admindata");
            }
        } catch (error) {
            console.error("Error parsing admin data:", error);
            localStorage.removeItem("admindata");
        }
    }, []);
    useEffect(() => {
        setFilteredItems(data);
    }, [data]);
    const fetch = () => {
        dispatch(getAllPlans());
    }

    useEffect(() => {
        fetch()
    }, [dispatch]);

    const handleEdit = (record) => {
        setEditingRecord(record);
        setIsEditingModelVisible(true);
    };

    const handleDelete = (record) => {
        console.log('the record ', record)
        Modal.confirm({
            title: 'Are you sure you want to delete this Plan?',
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            onOk: async () => {
                try {
                    const resp = await (deletePlan(record._id));
                    if (resp?.data?.success) {
                        dispatch(getAllPlans());
                        message.success('Plan deleted successfully');
                    } else {
                        message.error('Failed to delete user');
                    }
                } catch (error) {
                    message.error('An error occurred while deleting the user');
                }
            },
        });
    };
    const handleDetails = (record) => {
        setEditingRecord(record);
        setHandleDetailsVisible(true);
    };
    const handleEditCancel = () => {
        setIsEditingModelVisible(false);
    };

    const columns = [
        {
            title: ' Name',
            dataIndex: 'name',
            key: 'name',
            width: 300,
        },
        {
            title: 'Price',
            dataIndex: 'price',
            key: 'price',
            width: 300,
            render: (_, record) => {
                return (
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        {
                            record?.price
                        } ₹
                    </div>
                )
            }
        },
        {
            title: 'Duration(In Days)',
            dataIndex: 'duration',
            key: 'duration',
            width: 300,
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (_, record) => (
                <Space>

                    {
                        // admin?.role === 'superAdmin' &&
                        <div
                            style={{
                                display: 'flex',
                                width: "200px"
                            }}
                        >
                            <Button type="link" onClick={() => handleEdit(record)}>
                                Edit
                            </Button>
                            <Button type="link" onClick={() => handleDetails(record)}>
                                Details
                            </Button>
                            <Button type="link" danger onClick={() => handleDelete(record)}>
                                Delete
                            </Button>

                        </div>
                    }     </Space>
            ),
        },
    ];

    return (
        <div>
            {
                loading ?
                    <Loading /> :
                    <>
                        <div>
                            <Button
                                onClick={() => setAddPlanModel(true)}
                            >+ Add Plan</Button>
                            <Filter
                                allData={data}
                                setFilteredItems={setFilteredItems}
                                searchKeys={['name']}
                            />
                            <Layout>
                                <Content>
                                    <div style={{ overflowX: 'auto', width: '100%' }}>
                                        <Tabs
                                            activeKey={activeKey} onChange={handleChange}
                                        >
                                            <TabPane
                                                tab={"Franchise Plan"}
                                                key="1"
                                            >
                                                <Table
                                                    columns={columns}
                                                    pagination={{ position: ['bottomCenter'], pageSize: 10 }}
                                                    dataSource={
                                                        filteredItems?.filter(item => item?.planType === 'Franchise')
                                                    }
                                                    rowKey={(record) => record._id}
                                                    style={{ minHeight: '80vh', maxHeight: '80vh' }}
                                                />

                                            </TabPane>
                                            <TabPane
                                                tab={"Dealership Plan"}
                                                key="2"
                                            >
                                                <Table
                                                    columns={columns}
                                                    pagination={{ position: ['bottomCenter'], pageSize: 10 }}
                                                    dataSource={
                                                        filteredItems?.filter(item => item?.planType === 'Dealership')
                                                    }
                                                    rowKey={(record) => record._id}
                                                    style={{ minHeight: '80vh', maxHeight: '80vh' }}
                                                />

                                            </TabPane>
                                            <TabPane
                                                tab={"Sell Your Business Plan"}
                                                key="3"
                                            >
                                                <Table
                                                    columns={columns}
                                                    pagination={{ position: ['bottomCenter'], pageSize: 10 }}
                                                    dataSource={
                                                        filteredItems?.filter(item => item?.planType === 'SellYourBusiness')
                                                    }
                                                    rowKey={(record) => record._id}
                                                    style={{ minHeight: '80vh', maxHeight: '80vh' }}
                                                />
                                            </TabPane>
                                            <TabPane
                                                key="4"
                                                tab={"Investor"}
                                            >
                                                <Table
                                                    columns={columns}
                                                    pagination={{ position: ['bottomCenter'], pageSize: 10 }}
                                                    dataSource={
                                                        filteredItems?.filter(item => item?.planType === 'Investor')
                                                    }
                                                    rowKey={(record) => record._id}
                                                    style={{ minHeight: '80vh', maxHeight: '80vh' }}
                                                />
                                            </TabPane>
                                        </Tabs>
                                    </div>
                                </Content>
                                <Modal
                                    title="Add Plan"
                                    open={addPlanModel}
                                    onCancel={() => setAddPlanModel(false)}
                                    footer={null}
                                >
                                    <AddPlan
                                        setAddPlanModel={setAddPlanModel}
                                    />
                                </Modal>
                                <Modal
                                    title="Edit Plan"
                                    open={isEditingModelVisible}
                                    onCancel={handleEditCancel}
                                    footer={null}
                                >
                                    <EditPlan
                                        handleEditCancel={handleEditCancel}
                                        plan={editingRecord} />
                                </Modal>

                                {/* Details Modal */}
                                <Modal
                                    title="User Details"
                                    open={handleDetailsVisible}
                                    onCancel={() => setHandleDetailsVisible(false)}
                                    footer={null}
                                >
                                    <PlanDetails
                                        plan={editingRecord}
                                    />
                                </Modal>
                            </Layout>
                        </div>
                    </>

            }
        </div>
    )
}

export default Plan